import type {ReactElement} from 'react';
import React from 'react';
import {BaseOutlineColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-outline-color-panel';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromTextStylesOfSelectedTextSlideItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesOfSelectedTextSlideItem';
import type {RGBA} from '@Utils/color.util';

export function TextslideOutlineColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const strokeColor = useGetKeyFromTextStylesOfSelectedTextSlideItem('strokeColor');

  if (!activeItem?.isSlideshow()) {
    throw new Error(`Expected slideshow item but got ${activeItem?.gitype}`);
  }

  if (!activeSlideUID) {
    throw new Error('unable to get the selected text slide');
  }

  if (!strokeColor) {
    throw new Error('unable to get the stroke color for text slide');
  }

  const updateStrokeColor = (strokeColor: RGBA, undoable = true): void => {
    void activeItem.updateSlideFromObject(
      activeSlideUID,
      {
        textStyles: {
          strokeColor,
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseOutlineColorPanel strokeColor={strokeColor} onUpdateStrokeColor={updateStrokeColor} />;
}
